// ...existing code...
/**
 * Simple API URL and KONTRA URL configuration
 *
 * Priority:
 * 1. window.RUNTIME_CONFIG (injected at container runtime)
 * 2. window.VUE_APP_* globals (injected by entrypoint runtime-config.js)
 * 3. process.env (build-time VUE_APP_*)
 * 4. sensible defaults / hostname for production
 */

const runtimeConfig =
  typeof window !== 'undefined' && window.RUNTIME_CONFIG
    ? window.RUNTIME_CONFIG
    : {}
const win = typeof window !== 'undefined' ? window : {}
const env = typeof process !== 'undefined' && process.env ? process.env : {}

const getVar = (key, fallback) => {
  if (
    runtimeConfig &&
    runtimeConfig[key] !== undefined &&
    runtimeConfig[key] !== ''
  )
    return runtimeConfig[key]
  if (win && win[key] !== undefined && win[key] !== '') return win[key]
  if (env && env[key] !== undefined && env[key] !== '') return env[key]
  return fallback
}

// Resolve environment name
const envName = (getVar('VUE_APP_ENV') || getVar('NODE_ENV') || 'development')
  .toString()
  .toLowerCase()

let apiUrl
let apiKontraUrl
let apiBormaKpUrl
let bormaKpUrl

if (envName === 'production' || envName === 'prod') {
  const hostname = window.location.hostname
  apiUrl = `http://${hostname}:8083`
  apiKontraUrl = `http://${hostname}:84`
  apiBormaKpUrl = `http://${hostname}:8088`
  bormaKpUrl = `http://${hostname}:88`
} else {
  apiUrl = getVar('VUE_APP_API_URL', 'http://bis-backend')
  apiKontraUrl = getVar('VUE_APP_KONTRA_URL', 'http://bis-kontra-backend')
  apiBormaKpUrl = getVar('VUE_APP_API_BORMA_KP_URL', 'http://bis-borma-kp-backend/api')
  bormaKpUrl = getVar('VUE_APP_BORMA_KP_URL', 'http://bis-borma-kp-backend')
}

console.info('Detected environment:', envName)
console.info('API URL:', apiUrl)
console.info('KONTRA URL:', apiKontraUrl)
console.info('API BORMA KP URL:', apiBormaKpUrl)
console.info('BORMA KP URL:', bormaKpUrl)

// Expose for other scripts if window exists
if (typeof window !== 'undefined') {
  window.VUE_APP_API_URL = apiUrl
  window.VUE_APP_KONTRA_URL = apiKontraUrl
  window.VUE_APP_API_BORMA_KP_URL = apiBormaKpUrl
  window.VUE_APP_BORMA_KP_URL = bormaKpUrl
}

export { apiUrl as default, apiKontraUrl, apiBormaKpUrl, bormaKpUrl }